import React from "react"
import ShareButtonsStyle from "./ShareButtonsStyle.module.styl"

import { StickyShareButtons } from "sharethis-reactjs"

const ShareButtons = ({ slug }) => {
  return (
    <div className={ShareButtonsStyle.holder}>
      {/*<p className={ShareButtonsStyle.share_text}>Share</p>*/}
      {/*<FontAwesomeIcon icon={faTwitter} />*/}
      {/*<FontAwesomeIcon icon={faFacebookF} />*/}
      {/*<FontAwesomeIcon icon={faLinkedin} />*/}
      {/*<FontAwesomeIcon icon={faInstagram} />*/}

      <StickyShareButtons
        config={{
          alignment: "left",
          color: "social",
          enabled: true,
          font_size: 16,
          hide_desktop: false,
          labels: "counts",
          language: "en",
          min_count: 0,
          networks: ["facebook", "twitter", "pinterest", "email"],
          padding: 12,
          radius: 4,
          show_total: true,
          show_mobile: true,
          show_toggle: true,
          size: 48,
          top: 160,

          // OPTIONAL PARAMETERS
          url: `https://dianurse.netlify.app/blog/${slug}`,
        }}
      />
    </div>
  )
}

export default ShareButtons
